import Service from '@/helpers/service'

export default {

    // Career listings are served by the legacy system_tef_be backend
    // (open-position/index), not compro_tef_be. Field names differ there
    // (code_position, responsibilies) so we normalize them here to match
    // what Career.vue expects (code, responsibilities).
    index(params) {
        return Service().get('open-position/index', {params}).then((response) => {
            const paginator = response.data.data.data;
            response.data.data.data = (paginator.data || []).map((row) => ({
                ...row,
                code: row.code_position,
                responsibilities: row.responsibilies,
            }));
            return response;
        });
    },
}
